import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import Base from './input-base';
import { isFirefox, UNDEF } from '../../../fc-core/src/lib';

var fetchCoordFromEvent = function fetchCoordFromEvent(a) {
  return (a.originalEvent && (a = a.originalEvent), a.type.match(/touch/)) ? {
    x: a.touches[0].pageX,
    y: a.touches[0].pageY
  } : a.type.match(/mouse|pointer/) ? {
    x: a.pageX,
    y: a.pageY
  } : void 0;
},
    isSingleFinger = function isSingleFinger(a) {
  return !a.touches || 1 === a.touches.length;
},
    getDiffValXY = function getDiffValXY(c, a) {
  return {
    x: c.x - a.x,
    y: c.y - a.y
  };
};

var InputPan =
/*#__PURE__*/
function (_Base) {
  _inherits(InputPan, _Base);

  function InputPan() {
    var _this;

    _classCallCheck(this, InputPan);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputPan).call(this));

    var a = _assertThisInitialized(_assertThisInitialized(_this));

    a.controlArr = [{
      nativeInteraction: ['fc-dragstart', 'fc-dragmove'],
      callback: a.onDrag.bind(a),
      component: a
    }, {
      nativeInteraction: ['fc-dragend'],
      callback: a.onDragEnd.bind(a),
      component: a
    }], a.toggle = a.toggle.bind(a), isFirefox && a.controlArr.push({
      nativeInteraction: ['fc-mousedown'],
      callback: InputPan.mousedown,
      component: a
    });
    return _this;
  }

  _createClass(InputPan, [{
    key: "configure",
    value: function configure() {
      _get(_getPrototypeOf(InputPan.prototype), "configure", this).call(this);

      var a = this,
          b = a.config;
      b.skipGraphics || a.setLinkedItem('button', a.createButton({
        icon: 'panModeIcon',
        tooltext: a.config.tooltext,
        handlers: {
          click: a.toggle
        },
        state: 'activated'
      })), a.getLinkedParent().registerDependancy([{
        derivedInteraction: ['zoomin', 'zoomout', 'dragzoomenabled', 'dragzoomdisabled'],
        callback: a.dependancyFn,
        component: a
      }]), a.disable(UNDEF, !1);
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'dragPan';
    }
  }, {
    key: "enable",
    value: function enable(a, b) {
      var c = this;
      c._checkStackLen() && !0 !== c.config.enabled && (c.config.enabled = !0, c.config.state = 'pressed', c.fireEvent('panenabled'), !b && c.getFromEnv('chart').fireChartInstanceEvent('zoommodechanged', {
        panModeActive: !0
      }, a && a.originalEvent), c.setControl());
    }
  }, {
    key: "disable",
    value: function disable(a, b) {
      var c = this;
      !1 !== c.config.enabled && (c.config.enabled = !1, c.config.state = c._checkStackLen() ? 'activated' : 'disabled', c.fireEvent('pandisabled'), !b && c.getFromEnv('chart').fireChartInstanceEvent('zoommodechanged', {
        panModeActive: !1
      }, a && a.originalEvent), c.setControl());
    }
  }, {
    key: "setControl",
    value: function setControl() {
      var a = this,
          b = a.getLinkedParent(),
          c = a.getLinkedItem('button'),
          d = a.controlArr;
      b.releaseControl(d), a.isEnabled() && b.getControl(d), c && c.setCurrentState(a.isEnabled() ? a.config.state : 'disabled');
    }
  }, {
    key: "setDrag",
    value: function setDrag(a) {
      this.config.isDragging = !!a;
    }
  }, {
    key: "isDragging",
    value: function isDragging() {
      return !!this.config.isDragging;
    }
  }, {
    key: "onDragEnd",
    value: function onDragEnd() {
      this.setDrag(!1), this.getFromEnv('chart').getContainer('parentgroup').attr({
        cursor: 'default'
      });
    }
  }, {
    key: "onDrag",
    value: function onDrag(a) {
      var b,
          c,
          d,
          e,
          f,
          g,
          h,
          i,
          j,
          k,
          l,
          m = this,
          n = fetchCoordFromEvent(a.originalEvent);
      isSingleFinger(a.originalEvent) && (m.getFromEnv('chart').getContainer('parentgroup').attr({
        cursor: 'move'
      }), this.getFromEnv('animationManager').setAnimationState('drag'), m.isDragging() ? m.getFromEnv('axesObArr').forEach(function (a) {
        var m = Math.min;
        if (b = a.origConfig.minValue, c = a.origConfig.maxValue, f = a.axis, g = f.config.axisRange, h = f.getScale(), i = h.getRange(), j = h.getDomain(), k = (i[1] - i[0]) / (j[1] - j[0]), l = getDiffValXY(n, a.startCoord), e = c - b, d = a.isY ? l.y / k : l.x / k, d = -d, 0 < d) d = m(g.max - c, d);else if (0 > d) d = -m(b - g.min, -d);else return;
        b += d, c = b + e, f.setVisibleConfig(b, c);
      }) : (m.getFromEnv('axesObArr').forEach(function (a) {
        a.origConfig = a.axis.getVisibleConfig(), a.startCoord = n;
      }), m.setDrag(!0)));
    }
  }, {
    key: "dependancyFn",
    value: function dependancyFn(a) {
      var b = this;
      'zoomout' === a.type ? !b._checkStackLen() && b.disable() : 'zoomin' === a.type ? b.enable(a) : 'dragzoomdisabled' === a.type ? b._checkStackLen() && b.enable(a) : 'dragzoomenabled' === a.type && b.disable(a);
    }
  }], [{
    key: "mousedown",
    value: function mousedown(a) {
      a && a.preventDefault();
    }
  }]);

  return InputPan;
}(Base);

export default InputPan;